import cloneDeep from 'lodash/cloneDeep';
import {
  DEFAULT_VOICEBOX_SCHEMA,
  UNPROCESSED_VOICEBOX_TEST_IDS,
} from 'vet-bones/components/molecules/Voicebox';
import { VoiceboxCopy, VoiceboxTestIds } from 'vet-bones/constants/voicebox';
import { processTestIds } from 'vet-bones/utils';

export const voiceboxCopy: VoiceboxCopy = {
  ...DEFAULT_VOICEBOX_SCHEMA.copy,
  pending: {
    messages: ['Loading'],
    timeout: 0,
  },
};

const baseVoiceboxTestIds = cloneDeep(UNPROCESSED_VOICEBOX_TEST_IDS);
processTestIds(baseVoiceboxTestIds, '-', 'sd-voicebox');

export const voiceboxTestIds: VoiceboxTestIds = {
  ...baseVoiceboxTestIds,
};
